<script setup lang="ts">
/**
 * LoggedOutSidebar – desktop sidebar shown instead of NavigationButtonPanel while no
 * session is active (e.g. the Welcome/login screen, or an auth error page): no route
 * tabs, no logout button — only the language switcher, since neither makes sense before
 * a user is signed in.
 */
import LocaleSwitcher from '@/components/sidebar/LocaleSwitcher.vue'
</script>

<template>
  <nav
    class="fixed left-0 top-1/2 z-10 flex -translate-y-1/2 flex-col border-r border-tufte-border bg-tufte-bg font-tufte text-tufte-text"
    :style="{ width: 'var(--width-instrument-bar)' }"
  >
    <div class="px-4 py-3">
      <LocaleSwitcher />
    </div>
  </nav>
</template>
